import { Routes, Route, Navigate } from 'react-router-dom';
import { useLiffSession } from './hooks/useLiff';
import { Welcome } from './pages/Welcome';
import { Landing } from './pages/Landing';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { Coupons } from './pages/Coupons';
import { Rewards } from './pages/Rewards';
import { Profile } from './pages/Profile';
import { Points } from './pages/Points';
import { Products } from './pages/Products';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { CheckoutRedirect } from './pages/CheckoutRedirect';
import { Orders } from './pages/Orders';
import { OrderDetail } from './pages/OrderDetail';
import { BottomNav } from './components/BottomNav';
import { ImpersonationBanner } from './components/ImpersonationBanner';

export default function App() {
  const { status } = useLiffSession();

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        กำลังโหลด...
      </div>
    );
  }
  if (status === 'error') {
    return (
      <div className="min-h-screen flex items-center justify-center text-red-600 px-6 text-center">
        ไม่สามารถเชื่อมต่อ LINE ได้ — กรุณาเปิดผ่านลิงก์ใน LINE หรือลองใหม่อีกครั้ง
      </div>
    );
  }
  if (status === 'needs_login') {
    return <Welcome />;
  }

  // status === 'ready'
  return (
    <div className="min-h-screen pb-20">
      <ImpersonationBanner />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/shop" element={<Products />} />
        <Route path="/shop/products/:handle" element={<ProductDetail />} />
        <Route path="/shop/cart" element={<Cart />} />
        <Route path="/shop/redirecting" element={<CheckoutRedirect />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/:id" element={<OrderDetail />} />
        <Route path="/coupons" element={<Coupons />} />
        <Route path="/rewards" element={<Rewards />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/points"  element={<Points />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BottomNav />
    </div>
  );
}
